let messages = []
const listeners = new Set()
const notify = () => listeners.forEach(listener => listener())

export const showConfirmation = (message, options = {}) => {
    messages = [...messages, {
        message,
        title: options.title || (options.tone === 'warning' ? 'Please note' : options.tone === 'info' ? 'Information' : 'Success'),
        tone: options.tone || 'success',
    }]
    notify()
}

export const dismissConfirmation = () => {
    messages = messages.slice(1)
    notify()
}
export const getConfirmation = () => messages[0] || null
export const subscribeConfirmation = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}
